import { Grid, Button, LinearProgress, Typography, Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContextProvider";
import Api from "../api/Api";
import PollCard from "../components/PollCard";
import { ReactComponent as PollBackgroundImage } from '../components/icons/PollBackgroundImage.svg'
const ListPollPage = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [activePolls, setActivePolls] = useState([]);
    const [hasPolls, setHasPolls] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const getPolls = async () => {
            setActivePolls(await Api.getUserPolls(user.idem_guid, 'ACTIVE'))
            setHasPolls((await Api.userHasPolls(user.idem_guid))?.has_poll)
            setLoaded(true);
        }
        getPolls();
    }, [user])

    if (!user) {
        return null;
    }

    const removePoll = (/** @type {any[]} */ poll) => {
        setActivePolls(activePolls.filter((/** @type {any} */ mPoll) => mPoll !== poll))
    }

    return <Grid container spacing={2}>
        {!loaded && <Grid item xs={12}><LinearProgress /></Grid>}
        {activePolls.length === 0 && loaded &&
            <Grid container justifyContent={'center'}>
                <Stack spacing={2}>
                    <PollBackgroundImage style={{ maxWidth: 500, width: 500 }} />
                    <Typography variant='h5' sx={{ color: 'white' }}>
                        No poll found!
                    </Typography>
                    <Typography variant='subtitle1' sx={{ color: 'white' }}>
                        {!hasPolls ? `You haven't created any poll yet, why not kick things off with your very first poll?` : `You don’t have an active poll, want to create a new poll?`}
                    </Typography>
                    <Button variant={'outlined'} onClick={() => navigate('/create-poll')}>Create Poll</Button>
                </Stack>
            </Grid>
        }
        {(activePolls.length > 0) &&
            <>
                <Grid item xs={12}>
                    <Button variant={'outlined'} onClick={() => navigate('/create-poll')}>Create Poll</Button>
                </Grid>
                {activePolls.map((/** @type {any} */ poll, /** @type {import("react").Key} */ index) => <Grid key={index} item xs={12} lg={6}>
                    <PollCard poll={poll} onRemove={() => removePoll(poll)} remove />
                </Grid>)}
            </>}
    </Grid>
}

export default ListPollPage;